import { getRefreshToken, resendExpiredAPICall } from 'api/signin';
import axios from 'axios';
import local from 'store2';
import { SERVER_API_URL } from './constants';
import { updateAccessTokenInfo, updateRefreshTokenInfo } from "reducers/authenticationSlice";
import { store } from '../store';
import { logoutAction } from 'reducers/logoutAction';
import { DoctorLogin } from './routersConstants';

const TIMEOUT = 1 * 60 * 1000;
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL =  SERVER_API_URL;
const {dispatch} = store; // direct access to redux store.
const setupAxiosInterceptors = onUnauthenticated => {
  const onRequestSuccess = config => {
    const token = local.get('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    /*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
    if (config.url != "/signin" && config.url != "/register" && config.url != "/api/public/qrcode/generate" && config.url != "/sendResetPasswordToken") {
      const cU = local.get('cU');
      /*Bug#818 - Log out all tabs in one browser when one tab is logged out*- added by Aby Mar30-2022*/
      if((cU === null || cU === "" || cU === undefined) && store.getState().authentication.isAuthenticated){
        window.location.href = DoctorLogin.path;
      }
      /*Bug#818 - End*/
      
      /*Bug #681 @Author Aby Joseph @Date 25 Nov 2021 */
      if (config.method == 'post') {
        if (config.url == "/api/ccdaview" || config.url == "/api/book-appointment") {
          if (config.data) {
            if (!config?.data?.user_id) {
              config.data.user_id = cU;
            }
          } else {
            config.data = { user_id: cU };
          }
        } else {
          if (config.data) {
            if (!config?.data?.userId) {
              config.data.userId = cU;
            }
          } else {
            config.data = { userId: cU };
          }
        }
      } else {
        if (config?.params && !config?.params?.userId) {
          config.params.userId = cU;
        }
      }
    }
    /*Bug #681 - End*/
    return config;
  };
  //const onResponseSuccess = response => response;
  const onResponseSuccess = response => {
    return Promise.resolve(response);
  };
  const onResponseError = async err => {
    const status = err.status || (err.response ? err.response.status : 0);
    if (status === 403 || status === 401) {
      /*Bug#755  @author Aby Joseph on 09 Feb 2022*/
      if (err.response.config.url != "/refreshToken" ){
        let refreshToken = local.get('refreshToken');
        const response = await getRefreshToken(refreshToken);
        if(response?.data?.success)
        {
          dispatch(updateAccessTokenInfo(response?.data?.access_token));
          local.set('access_token',response?.data?.access_token);
          dispatch(updateRefreshTokenInfo(response?.data?.refresh_token));
          local.set('refreshToken',response?.data?.refresh_token);    
          /* Logout issue fix - old access token of concurrent calls replaced with new token @author Aby Joseph on 16 Jun 2022 */
          if ( response?.data?.access_token != null ) {
            err.response.config.headers.Authorization = `Bearer ${response?.data?.access_token}`;
          }
          /*Logout issue fix - old access token of concurrent calls replaced with new token - end */
          const resendResponse = await resendExpiredAPICall(err.response.config);
          return Promise.resolve(resendResponse);
        }
      }else{
        logoutAction();
      }
      /*Bug#755  End*/
      onUnauthenticated();
    }
    return Promise.reject(err);
  };
  
  axios.interceptors.request.use(onRequestSuccess);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};


export default setupAxiosInterceptors;
/*Bug #755 end */
